import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cached module-level promise so the call is shared across components and the
// fetch only happens once per page load.
let cachedPromise = null;

const fetchEventMode = () => {
  if (!cachedPromise) {
    cachedPromise = axios
      .get(`${API_URL}/event-mode`)
      .then((r) => r.data)
      .catch(() => ({ enabled: false, label: { tr: '', en: '' } }));
  }
  return cachedPromise;
};

/**
 * Returns the EVENT_MODE backend flag plus the localized label.
 *   const { enabled, label } = useEventMode();
 * Defaults to `{enabled: false}` until the request resolves so paywalls stay
 * intact on a slow network.
 */
export default function useEventMode() {
  const [state, setState] = useState({ enabled: false, label: { tr: '', en: '' }, loaded: false });

  useEffect(() => {
    let cancelled = false;
    fetchEventMode().then((data) => {
      if (!cancelled) setState({ ...data, loaded: true });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
